export const SERVICE_HOURS = "Tutti i giorni, 06:30–21:00 (ora svizzera)";
const formatter = new Intl.DateTimeFormat("en-GB", {
  timeZone: "Europe/Zurich", year: "numeric", month: "2-digit", day: "2-digit",
  hour: "2-digit", minute: "2-digit", hourCycle: "h23", weekday: "short",
});

function parts(date) {
  if (!date || !Number.isFinite(date.getTime())) return null;
  return Object.fromEntries(formatter.formatToParts(date).map(p => [p.type, p.value]));
}

export function swissServiceTime(date) {
  const p = parts(date);
  if (!p) return { isOpen: false, time_slot: null, is_weekend: false };
  const minutes = Number(p.hour) * 60 + Number(p.minute);
  return {
    isOpen: minutes >= 390 && minutes < 1260,
    time_slot: minutes < 480 ? "night" : minutes < 1080 ? "day" : "evening",
    is_weekend: p.weekday === "Sat" || p.weekday === "Sun",
  };
}

// datetime-local is explicitly Swiss wall time, independent of the device zone.
export function fromSwissLocalInput(value) {
  const m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(value || "");
  if (!m) return null;
  const target = Date.UTC(...[Number(m[1]), Number(m[2]) - 1, ...m.slice(3).map(Number)]);
  let candidate = new Date(target);
  for (let i = 0; i < 3; i++) {
    const p = parts(candidate);
    const rendered = Date.UTC(Number(p.year), Number(p.month) - 1, Number(p.day), Number(p.hour), Number(p.minute));
    candidate = new Date(candidate.getTime() + target - rendered);
  }
  const p = parts(candidate);
  return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}` === value ? candidate : null;
}
